
import InfoBox from "@/components/InfoBox/InfoBox.vue";
import ExtratoFinanceiro from "@/components/ExtratoFinanceiro/ExtratoFinanceiro.vue";
import { SistemaMixin } from "@/modules/Application";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "DashboardFinanceiro",
  mixins: [SistemaMixin],
  components: {
    InfoBox,
    ExtratoFinanceiro,
    Money,
  },
  data() {
    return {
      filtroPeriodo: "month",
      filtroStatus: "todas",
      dataInicio: null,
      dataFim: null,
      mostrarSaldo: false,
      mostrarModalTransferencia: false,
      transferencia: {
        tipo: "EMAIL",
        chave: "",
        valor: null,
        descricao: "",
      },
      tiposChave: [
        { value: "EMAIL", text: "E-mail" },
        { value: "CPF", text: "CPF" },
        { value: "CNPJ", text: "CNPJ" },
        { value: "PHONE", text: "Telefone" },
      ],
      configMoney: settingMoney,
      dados: {
        saldo_em_conta: 0,
        recebidas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
        confirmadas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
        aguardando_pagamento: {
          valor_total: 0,
          liquido: 0,
          clientes: 0,
          cobrancas: 0,
        },
        vencidas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
      },
    };
  },
  computed: {
    labelPeriodo() {
      switch (this.filtroPeriodo) {
        case "day":
          return "Hoje";
        case "month":
          return "Este Mês";
        case "week":
          return "Esta semana";
        case "year":
          return "Este ano";
        case "personalizado":
          return "Personalizado";
        default:
          return "Período";
      }
    },
  },
  mounted() {
    this.buscarDadosDashboard();
  },
  methods: {
    alternarSaldo() {
      this.mostrarSaldo = !this.mostrarSaldo;
    },
    setFiltro(periodo) {
      this.filtroPeriodo = periodo;
      this.dataInicio = null;
      this.dataFim = null;
      if (periodo !== "personalizado") this.buscarDadosDashboard();
    },
    async buscarDadosDashboard() {
      try {
        const response = await this.$http.post("/bancos/dashboard-financeiro", {
          periodo: this.filtroPeriodo,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
        });
        this.dados = response.data;
      } catch (error) {
        console.error("Erro ao buscar dados do dashboard:", error);
      }
    },
    aplicarFiltro(status) {
      this.filtroStatus = status;
      this.buscarDadosDashboard();
    },
    async enviarTransferencia() {
      try {
        await this.$http.post(
          "/bancos/enviar-transferencia",
          this.transferencia
        );
        this.$toast.success("Transferência realizada com sucesso!");
        this.mostrarModalTransferencia = false;
      } catch (e) {
        this.$toast.warning("Erro ao realizar transferência");
      }
    },
  },
};
